import { render, staticRenderFns } from "./EditTextPopup.vue?vue&type=template&id=7adfd1c8&"
import script from "./EditTextPopup.vue?vue&type=script&lang=js&"
export * from "./EditTextPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports